import { Component, OnInit } from '@angular/core';

@Component({
	selector: 'app-payment-result25',
	templateUrl: './payment-result.component.html',
	styleUrls: ['./payment-result.component.css']
})
export class PaymentResultComponent25 implements OnInit {

	constructor() {}

	ngOnInit(): void {}

}
